import styled from "@emotion/styled";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { Icon } from "../icon";

interface BackToButtonProps {
  title: string;
  url: string;
}

export function BackToButton(props: BackToButtonProps) {
  return (
    <BackToWrapper>
      <Link href={props.url}>
        <Icon icon={faArrowLeft} />
      </Link>
      <BackToTitle>{props.title}</BackToTitle>
    </BackToWrapper>
  );
}

const BackToWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Link = styled.a`
  height: 36px;
  width: 36px;
  margin-right: 8px;
  padding: 9px 13px;
  border: 1px solid ${(props) => props.theme.colors.purple[60]};
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackToTitle = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.purple[100]};
`;
